import React, { FC, useState, memo } from 'react';
import { StatusTip, Switch } from 'tea-component';
import Distribution from './Distribution';
import RetentionCurve from './RetentionCurve';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TipContext from '@/pages/home/components/TipContext';
import { useIntl } from 'umi';

import './index.scss';

const { LoadingTip } = StatusTip;

interface RetentionProps {
  loading: boolean;
  retentionCurve: any[];
  arpuRetention: any[];
  gameTotal: number;
}

const Retention: FC<RetentionProps> = (props) => {
  const {
    loading = false,
    retentionCurve,
    arpuRetention,
    gameTotal
  } = props;
  const { formatMessage } = useIntl();
  const [isAllGame, setAllGame] = useState(false)

  return (
    <div className="dbi-benchmark-rowbox figure-retention-container">
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-benchmark-arpu-retention benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({ id: 'dbi_benchmark_mobile_arpudau_curve' })}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={<div>
                <div>{formatMessage({id: 'dbi_benchmark_mobile_gass_capability_info_x'})}</div>
                <div>{formatMessage({id: 'dbi_benchmark_mobile_gass_capability_info_y'})}</div>
              </div>}
              // tipText={formatMessage({id: 'dbi_benchmark_mobile_gass_capability_info'})}
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : arpuRetention?.length > 0 ? (
          <>
            {
              arpuRetention?.length > 20 &&
              <div className='dbi-benchmark-pull-all-games-container'>
                <span className="arpu-retention-switch-label">
                  {formatMessage({ id: 'dbi_benchmark_put_all_games' })}
                </span>
                <Switch value={isAllGame} onChange={(value)=> setAllGame(value) } />
              </div>
            }
            <Distribution gameList={arpuRetention} isAllGame={isAllGame}/>
          </>
        ) : (
          <div className="retention-top-game-container-loading retention-no-data">
            {formatMessage({ id: 'dbi_detail_no_data_under' })}
          </div>
        )}
      </CardSlotV2>
      <CardSlotV2
        className="dbi-benchmark-cardbox dbi-benchmark-arpu-retention benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({ id: 'dbi_benchmark_retention_curve' })}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={ formatMessage({id: gameTotal> 6 ? 'dbi_benchmark_retention_curve_mobile_info': 'dbi_benchmark_retention_curve_mobile_info_6'})}
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : retentionCurve?.length > 0 ? (
          <RetentionCurve gameRetentionList={retentionCurve} gassGameNum={arpuRetention?.length|| 0}/>
        ) : (
          <div className="retention-top-game-container-loading retention-no-data">
            {formatMessage({ id: 'dbi_detail_no_data_under' })}
          </div>
        )}
      </CardSlotV2>
    </div>
  );
};

Retention.defaultProps = {
  retentionCurve: [],
};

export default memo(Retention);
